import { render, staticRenderFns } from "./JewelryItems.vue?vue&type=template&id=52e59a3a&scoped=true"
import script from "./JewelryItems.vue?vue&type=script&lang=js"
export * from "./JewelryItems.vue?vue&type=script&lang=js"
import style0 from "./JewelryItems.vue?vue&type=style&index=0&id=52e59a3a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52e59a3a",
  null
  
)

export default component.exports